export default __webpack_public_path__ + "static/media/home-nav.ebc68ec8.svg";